import { LuSkull, LuFlame } from 'react-icons/lu'
import { HiBolt } from 'react-icons/hi2'
import { TbWaveSawTool } from 'react-icons/tb'
import type { InterestVerdict } from 'api/league'
import type { VerdictConfig } from 'types/interest'

export const VERDICT_CONFIG: Record<InterestVerdict, VerdictConfig> = {
  boring:      { label: 'Dead Quiet',  Icon: LuSkull,        color: '#8a8a8a', trackColor: 'rgba(138,138,138,0.1)' },
  ok:          { label: 'Decent',      Icon: TbWaveSawTool, color: '#e8a020', trackColor: 'rgba(232,160,32,0.1)'  },
  interesting: { label: 'Heating Up', Icon: HiBolt,         color: '#31afb4', trackColor: 'rgba(49,175,180,0.1)'  },
  spicy:       { label: 'Full Chaos', Icon: LuFlame,        color: '#f05a22', trackColor: 'rgba(240,90,34,0.1)'   },
}
